import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IonicModule, ModalController } from '@ionic/angular';
import * as fromPlaato from "app/state/plaato/reducer";
import { Store } from '@ngrx/store';
import { IPlaatoVM } from 'app/models/plaato';
import * as fromTap from 'app/state/tap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-select-plaato',
  templateUrl: './select-plaato.component.html',
  styleUrls: ['./select-plaato.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class SelectPlaatoComponent implements OnInit {

  items$!: Observable<IPlaatoVM[]>;

  constructor(
    private plaatoStore: Store<fromPlaato.State>,

    private modalController: ModalController,
  ) { }

  ngOnInit() {

    this.items$ = this.plaatoStore.select(fromTap.getPlaatosWithTap);

  }

  closeModal() {
    this.modalController.dismiss();
  }

  selectItem(item: IPlaatoVM) {
    this.modalController.dismiss({
      item
    });
  }







}
